import { get, handleError } from '@/lib/http-adapter';
import { ClassPackCode } from '@/state/class-pack-code';
import { User } from '@/state/user';

export const getClassPackCodes = async (filters?: {
    user_id?: ClassPackCode['user_id'];
    email?: User['email'];
}) => {
    try {
        const response = await get<{
            class_pack_codes: ClassPackCode[];
        }>('public/class-pack-codes', { params: filters });
        return response?.class_pack_codes;
    } catch (error) {
        handleError(error);
    }
};

